import { NavigateFunction, useLocation } from "react-router-dom"
import { headers } from "../../App/Axios"
import HTTPService from "../../App/HTTPService"
import { setRoomMembers } from "../Room/RoomSlices/MembersInRoomSlice"
import { setModalData } from "../Shared/SharedSlices/ModalSlice"

export const upcomingUserEventsGetRequest = () => {
    return HTTPService.get(`/events/upcoming/`, headers)
}

export const upcomingOrganizationEventsGetRequest = (orgId: string) => {
    return HTTPService.get(`/events/upcoming?org_id=${orgId}`, headers)
}